import {Component, OnInit, Sanitizer} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {IdvUploadDto, SofDecisionDto} from '../../../dto/idv-upload';
import {BankTransferLoadService} from '../../../bank-transfer-load.service';
import {CustomersService} from '../../services/customers.service';
import {DatePipe, Location} from '@angular/common';
import {Customer} from '../../../dto/customer';
import {TrustPayTransaction} from '../../../dto/trustPayTransaction';
import {TrustPayService} from '../../../trust-pay.service';
import {toDateString, toDateTimeString} from '../../../providers/app-date-adapter';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ToastService} from 'angular-toastify';
import {AddressStatus, IdentLevel, IdentStatus} from "../../../dto/ident-status";
import {PepStatus} from '../../../dto/pep-status';
import {RoleService} from '../../../services/role.service';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {EmailSendStatus} from '../../../dto/order-status';
import {byNumeric} from 'iso-country-codes';
import {
  getIdentStatusColor,
  getIdentStatusIcon, getIdentStatusText,
  getPepStatusColor,
  getPepStatusText
} from "../../../helpers/pep-status-helper";
import {ConfirmDialogComponent} from "../../../shared/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {MarkVulnerableDialogComponent} from "../../customers/mark-vulnerable-dialog/mark-vulnerable-dialog.component";
import {MarkCustomerAsVulnerableModel} from "../../../models/mark-customer-as-vulnerable-model";

@Component({
  selector: 'app-sof-generic-detail',
  templateUrl: './sof-generic-detail.component.html',
  styleUrls: ['./sof-generic-detail.component.css']
})
export class SofGenericDetailComponent implements OnInit {
  private customerId: number;
  uploadedFiles: IdvUploadDto[] = [];
  isLoading = false;
  customer: Customer|null;
  previewFileOpen = false;
  urlSafe: SafeResourceUrl;
  isImgHidden = false;
  isFrameHidden = false;
  filename = '';
  errorMsg = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private customersService: CustomersService,
    private location: Location,
    private trustPayService: TrustPayService,
    public datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private _toastService: ToastService,
    private roleService: RoleService,
    private dialog: MatDialog,

  ) { }

  decision = 0;
  decisionComment = '';
  decisionCustomerIncome: number|null;
  decisionCustomerIncomeType: number|null;
  notAllFilesStatusSet = true;
  isSavingDecision = false;

  decisionNecessary = false;


  identStatus = IdentStatus;
  pepStatus = PepStatus;


  fields = [
    {header: 'Name', cell: (row: Customer) => `${row.title || ''} ${row.firstName} ${row.lastName}`} as ContentRowField<Customer>,
    /*{ header: "Title", cell: (row: Customer) => `${row.title}` },
    { header: "First name", cell: (row: Customer) => `${row.firstName || ""}` },
    { header: "Last name", cell: (row: Customer) => `${row.lastName || ""}` },*/
    {header: 'Address', cell: (row: Customer) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}`} as ContentRowField<Customer>,
    {header: 'Country', cellFlag: (row: Customer) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row: Customer) => `${row.countryName || ''}`} as ContentRowField<Customer>,
    /*{ header: "Address", cell: (row: Customer) => `${row.address || ""}` },
    { header: "City", cell: (row: Customer) => `${row.city || ""}` },
    { header: "Zip code", cell: (row: Customer) => `${row.zipCode || ""}` },*/
    { header: 'Email',
      icon: (row: Customer) => this.getEmailIcon(row),
      cellColor: (row: Customer) => this.getEmailIconColor(row),
      iconColor: (row: Customer) => this.getEmailIconColor(row),
      cell: (row: Customer) => `${row.email || ''}`
    } as ContentRowField<Customer>,


    {header: 'Mobile', cell: (row: Customer) => `+${row.phone || ''}`} as ContentRowField<Customer>,
    {header: 'Date of birth', cell: (row: Customer) => {
        if ( !row.dob ) {
          return '-';
        }
        return toDateString(row.dob);
      }} as ContentRowField<Customer>,
    /*{header: "Age", cell: (row: Customer) => {
        if ( !row.dob )
          return "-";
        return toAge(row.dob) + " years"
      }},*/
    {
      header: 'Order language'
      , cellFlag: (row: Customer) => {
        if (row.orderLanguage == 0) {
          return 'de';
        } else {
          return 'gb';
        }
      }

      , cell: (row: Customer) => {
        if (row.orderLanguage == 0) {
          return 'german';
        } else {
          return 'english';
        }
      }
    } as ContentRowField<Customer>,
    {header: 'IP Address', cell: (row: Customer) => `${row.ipAddress || ''}`} as ContentRowField<Customer>,
    {header: 'Subscribed to news', cell: (row: Customer) => `${row.subscribeToNews ? 'Yes' : 'No' || ''}`} as ContentRowField<Customer>,
    {
      header: 'Ident',
      iconColor: row => getIdentStatusColor(row.identStatus),
      icon: (row: Customer) => getIdentStatusIcon(row.identStatus),
      cell: row => getIdentStatusText(row.identStatus),
    } as ContentRowField<Customer>,
    {
      header: 'PEP Status',
      iconColor: row => getPepStatusColor(row.pepStatus),
      icon: (row: Customer) => 'perm_identity',
      cell: row => getPepStatusText(row.pepStatus),
    } as ContentRowField<Customer>,
    /*{
      header: "IDV Link Status", cell: (row: Customer) => {
        if (row.idvSuccess == null) {
          return "-";
        }
        if (row.idvSuccess) {
          return "Success";
        } else {
          return "Failed";
        }
      }
    },
    {
      header: "Docs Link Status", cell: (row: Customer) => {
        if (row.docsSuccess == null) {
          return "-";
        }
        if (row.docsSuccess) {
          return "Success";
        } else {
          return "Failed";
        }
      }
    },*/

  ] as ContentRowField<Customer>[];


  getEmailIconColor(row: Customer): string|boolean {
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable && row.emailRejectedCount >= 3) {
      return '#ff0000';
    }
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable) {
      return '#ff9900';
    }

    if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
      return '#008400';
    }

    return false;
  }

  getEmailIcon(row: Customer): string|boolean {
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable ) {
      return 'front_hand';
    }
    if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
      return 'mark_email_read';
    }
    return 'email';

  }

  ngOnInit(): void {
    this.customerId = parseInt(this.route.snapshot.paramMap.get( 'id' ));
    this.loadData();
  }

  loadData(): void {

    this.isLoading = true;

    this.customersService.get(this.customerId).subscribe(customer => {
      this.customer = customer;
    });

    this.customersService.getOnlySofGeneric(this.customerId).subscribe(files => {
      this.uploadedFiles = files;
      this.uploadedFiles.forEach(f => {
        if ( f.isSuccess === null ) {
this.decisionNecessary = true;
}
      });
      this.handleFileStatusChange();
      this.isLoading = false;
    });

  }

  returnBack() {
    this.location.back();
  }

  previewFile(fileId: number) {
    this.isLoading = true;
    this.previewFileOpen = true;
    this.customersService.getFileInline( fileId ).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        const blob = new Blob([result.body], { type: contentType });
        // FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if ( contentType.indexOf('image') >= 0) {
          this.isImgHidden = false;
          this.isFrameHidden = true;

        } else {
          this.isImgHidden = true;
          this.isFrameHidden = false;

        }
        this.errorMsg = null;
        this.filename = filename;



        this.isLoading = false;

        // FileHelper.saveFile( result );
      },
      err => {
        this.filename = null;
        this.isImgHidden = true;
        this.isFrameHidden = true;
        this.errorMsg = 'Error occured during downloading the file.';
        this.isLoading = false;
        this._toastService.error( err.error.message || err.message || err.error || err);
      }

    );
  }

  closePreview() {
    this.previewFileOpen = false;
  }

  saveDecision() {
    const decisionDto = {
      decision: this.decision,
      decisionComment: this.decisionComment,
      customerIncome: this.decisionCustomerIncome,
      customerIncomeType: this.decisionCustomerIncomeType,
      files: this.uploadedFiles,
      bankTransferLoadId: null,
      customerId: this.customerId,
      customerYearlyIncome: this.decisionCustomerIncome,
      customerMainIncomeSource: this.decisionCustomerIncomeType,

    } as SofDecisionDto;

    this.isSavingDecision = true;
    this.customersService.saveSofDecision(decisionDto).subscribe(data => {
      this._toastService.success('The decision was saved and the customer informed');
      this.isSavingDecision = false;

      this.router.navigate(['../../../idv-customers-overview/' + this.customerId], {relativeTo: this.route});

    }, err => {
      this._toastService.error(err.error.message || err.error || err.message);
      this.isSavingDecision = false;
    });


  }

  handleFileStatusChange() {
    let allSet = true;
    this.uploadedFiles.forEach(uf => {
      if ( uf.isSuccess === null ) {
        allSet = false;
      }
    });
    this.notAllFilesStatusSet = !allSet;
  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  markAsVulnerable(customer: Customer) {

    this.isMarkingAsVulnerable = true;
    const dialogRef = this.dialog.open(MarkVulnerableDialogComponent, {
      data: {
        title: 'Mark customer as vulnerable',
        text: 'Are you sure want to mark this customer as vulnerable?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result instanceof MarkCustomerAsVulnerableModel) {
        this.customersService.markVulnerable(customer.id, result.reason, 'SOF').subscribe(_ => {
          this.customer.isVulnerable = true;
          this.customer.vulnerableDate = new Date();
          this.customer.vulnerableReason = result.reason;
          this._toastService.info('Customer was marked as vulnerable');
          this.isMarkingAsVulnerable = false;
        });
      } else {
        this.isMarkingAsVulnerable = false;
      }
    });



  }

  isMarkingAsVulnerable = false;

  protected readonly addressStatus = AddressStatus;
  protected readonly identLevel = IdentLevel;
}
